<template>
  <div>
    <v-container class="mx-auto pa-sm-3 pa-0" style="max-width:1280px">
      <v-row>
        <v-col cols="12" sm="4" class="py-0">
          <v-autocomplete
            label="Choose Your Location"
            :items="areas"
            :search-input.sync="searchArea"
            :item-text="areaText"
            :value="area"
            hide-details
            class="pa-0 elevation-10 input-background"
            background-color="green"
            dark
            filled
            append-icon="mdi-map-marker"
            style="border-radius:0;background-image:url('https://unsplash.it/2000/1125?image=479')"
            v-on:change="changeArea"
            ref="area"
            return-object
          >
            <template v-slot:prepend-item="">
              <v-list-item @click="findLocation">
                <div class="green--text font-weight-bold">
                  Find my location
                </div>
              </v-list-item>
              <v-divider></v-divider>
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="mx-auto pb-0" style="max-width:1280px">
      <v-row>
        <v-col cols="4" sm="12" class="py-0" v-if="isRefineMode">
          <v-subheader style="white-space:nowrap;font-size:12px">I am looking for ...</v-subheader>
        </v-col>
        <v-col cols="8" sm="4" class="pt-0 pb-3" v-if="isRefineMode">
          <v-select
            label="Choose Service Provider"
            v-model="type"
            :items="types"
            single-line
            hide-details
            class="pa-0 ma-0"
            clearable
            solo
            filled
            :background-color="$vuetify.theme.dark ? '' : 'grey lighten-4'"
            flat
            dense
            v-on:change="startSearch"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="4" class="pt-0" v-if="isRefineMode">
          <v-autocomplete
            ref="input2"
            label="Search All Categories"
            v-model="term"
            :items="terms"
            :search-input.sync="searchTerm"
            :item-text="categoryText"
            hide-details
            class="pa-0 ma-0"
            single-line
            clearable
            outlined
            dense
            v-on:change="startSearch"
            return-object
          ></v-autocomplete>
        </v-col>
        <!-- <v-col cols="6" sm="4" class="pt-0">
          <v-autocomplete
            label="Subcategory"
            :items="items"
            hide-details
            class="pa-0 ma-0"
            single-line
            outlined
            dense
          ></v-autocomplete>
        </v-col> -->
        <v-col cols="12" sm="4" class="pt-0" :style="!isRefineMode ? 'margin-top:3px' : ''">
          <v-text-field
            ref="input"
            class="search-bar pa-0"
            v-model="search"
            placeholder="Type Keyword to search"
            hide-details
            outlined
            dense
            clearable
            @keydown.enter="startSearch"
            @click:clear="clearStartSearch"
            append-icon="mdi-tune"
            @click:append="toggleRefineMode"

          >
            <template v-slot:append-outer>
              <v-btn
                @click="startSearch"
                fab
                small
                :color="$vuetify.theme.dark ? '' : 'white'"
                class="green--text elevation-4"
                style="margin-top:-8px; margin-bottom:-5px"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </template>
          </v-text-field>
        </v-col>
        <v-col cols="12" class="pt-0">
          <v-slider
            v-model="radius"
            hide-details
            color="green"
            :label="radiusLabel"
            inverse-label
            :max="3"
            step="1"
            ticks="always"
            tick-size="6"
            @change="startSearch"
          ></v-slider>
        </v-col>
        <!-- <v-col cols="5" sm="4" class="pt-0">
          append-icon="mdi-magnify"
          <v-btn @click="startSearch" block depressed height="40px"><v-icon left>mdi-map-search-outline</v-icon> Search</v-btn>
        </v-col> -->
      </v-row>
    </v-container>
    <!-- <v-divider></v-divider> -->
    <v-container class="mx-auto pa-sm-3 pa-0 hidden-xs-only" style="max-width:1280px">
      <v-row>
        <v-col cols="6">
          <v-toolbar
            flat
          >
            <div class="body-2 grey--text text--darken-2">{{totalCount}} results</div>
            <v-spacer></v-spacer>
            <v-subheader>Sort by:</v-subheader>
            <v-chip-group
              mandatory
              active-class="primary--text"
              v-model="tag"
              @change="startSearch"
            >
              <v-chip class="rounded-l-xl mr-0 slide-chip" :class="{['slide-chip-active']: tag == 0}" key="Rating">
                <v-rating
                  class="no-notranslate"
                  :value="3"
                  color="yellow accent-4"
                  dense
                  half-increments
                  readonly
                  size="18"
                  empty-icon="no-icon"
                >{{tag}}</v-rating>
              </v-chip>
              <v-chip class="rounded-r-xl slide-chip" :class="{['slide-chip-active']: tag == 1}" key="Distance">
                Distance
              </v-chip>
            </v-chip-group>
          </v-toolbar>
          <v-list three-line style="max-height:416px;overflow-y: auto;">
            <template v-for="(item, i) in results">
              <template v-if="i !== 0 && i % 4 === 0">
                <Ad @open="test($event)" :n="i + i / 4" :key="i + 500000"/>
              </template>
              <v-list-item
                :key="item._id"
                @click="test(item._id)"
              >
                <v-list-item-avatar>
                  <v-img
                    transition="false"
                    :src="$http.defaults.baseURL + '/images/' + item.image"
                    :lazy-src="$http.defaults.baseURL + '/images/' + item.lazyImage"
                  ></v-img>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title>{{item.name}}</v-list-item-title>
                  <v-list-item-subtitle><strong>{{item.title}}</strong></v-list-item-subtitle>
                  <v-list-item-subtitle>
                    <v-rating
                      :value="item.rating ? item.rating : 0"
                      color="yellow accent-4"
                      dense
                      half-increments
                      readonly
                      size="18"
                    ></v-rating>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-list-item-action-text>{{(item.distance * 0.001).toFixed(2)}} km from you</v-list-item-action-text>
                </v-list-item-action>
              </v-list-item>
            </template>
            <v-btn
              v-if="results.length < totalCount"
              :loading="loadMore"
              :disabled="loadMore"
              tile
              block
              x-large
              color="success"
              @click="startSearch(true)"
            >Show more</v-btn>
          </v-list>
        </v-col>
        <v-col cols="6">
          <!-- <google-map :name="test"></google-map> -->
          <l-map
            style="height: 480px; width: 100%; z-index: 0;"
            :zoom="zoom"
            :center="area ? area.location.coordinates : [0, 0]"
            @update:zoom="zoomUpdated"
            @update:center="centerUpdated"
            @update:bounds="boundsUpdated"
          >
            <l-tile-layer :url="url"></l-tile-layer>
            <l-marker @click="openSheet(x)" v-for="x in results" :key="x._id" :lat-lng="x.location.coordinates">
              <l-tooltip :options="options">{{x.name}}</l-tooltip>
            </l-marker>
          </l-map>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="mx-auto pa-sm-3 pa-0 hidden-sm-and-up" style="max-width:1280px">
      <div>
        <v-btn class="rounded-tl-xl tab-button" :class="{['tab-button-active']: tab == 0, ['primary--text']: tab == 0}"
          :color="(tab == 1 && ($vuetify.theme.dark ? '#000' : '#e8eef9')) || (tab == 0 && ($vuetify.theme.dark ? '#272727' : '#fff'))"
          tile :elevation="tab == 0 ? 15 : 0" @click="tab = 0">Display map</v-btn>

        <v-btn class="rounded-tr-xl tab-button" :class="{['tab-button-active']: tab == 1, ['primary--text']: tab == 1}"
          :color="(tab == 0 && ($vuetify.theme.dark ? '#000' : '#e8eef9')) || (tab == 1 && ($vuetify.theme.dark ? '#272727' : '#fff'))"
          tile :elevation="tab == 1 ? 15: 0" @click="tab = 1">Display list</v-btn>
      </div>
      <!-- <v-tabs
        color="primary"
        left
        grow
        v-model="tab"
      >
        <v-tab key="1">Display map</v-tab>
        <v-tab key="2">Display list</v-tab>
      </v-tabs> -->
      <v-tabs-items v-model="tab" touchless>
        <v-tab-item key="afwfaw">
          <!-- <google-map :name="name"></google-map> -->
          <l-map
            style="height: 543px; width: 100%; z-index: 2;"
            :zoom="zoom"
            :center="area ? area.location.coordinates : [0, 0]"
            @update:zoom="zoomUpdated"
            @update:center="centerUpdated"
            @update:bounds="boundsUpdated"
          >
            <l-tile-layer :url="url"></l-tile-layer>
            <l-marker @click="openSheet(x)" v-for="x in results" :key="x._id" :lat-lng="x.location.coordinates">
              <l-tooltip :options="options">{{x.name}}</l-tooltip>
            </l-marker>
          </l-map>
        </v-tab-item>
        <v-tab-item key="awfawf">
          <v-toolbar
            flat
            style="z-index: 1;"
          >
            <div class="body-2 grey--text text--darken-2">{{totalCount}} results</div>
            <v-spacer></v-spacer>
            <v-subheader>Sort by:</v-subheader>
            <v-chip-group
              mandatory
              active-class="primary--text"
              v-model="tag"
              @change="startSearch"
            >
              <v-chip class="rounded-l-xl mr-0 slide-chip" :class="{['slide-chip-active']: tag == 0}" key="Rating">
                <v-rating
                  class="no-notranslate"
                  :value="3"
                  color="yellow accent-4"
                  dense
                  half-increments
                  readonly
                  size="18"
                  empty-icon="no-icon"
                >{{tag}}</v-rating>
              </v-chip>
              <v-chip class="rounded-r-xl slide-chip" :class="{['slide-chip-active']: tag == 1}" key="Distance">
                Distance
              </v-chip>
            </v-chip-group>
            <!-- <v-btn class="rounded-l-xl" small>Rating</v-btn>
            <v-btn class="rounded-r-xl" small>Distance</v-btn> -->
          </v-toolbar>
          <v-row justify="center" v-if="!list">
            <!-- <v-progress-circular
              :size="70"
              :width="7"
              color="primary"
              indeterminate
            ></v-progress-circular> -->
            <v-skeleton-loader
              v-for="(item, i) in items"
              :key="i"
              class="px-3 py-2"
              type="list-item-avatar-two-line"
              width="100%"
            ></v-skeleton-loader>
          </v-row>
          <v-list three-line v-if="list">
            <template v-for="(item, i) in results">
              <template v-if="i !== 0 && i % 4 === 0">
                <Ad @open="test($event)" :n="i + i / 4" :key="i + 500000"/>
              </template>
              <v-list-item
                :key="item._id"
                @click="test(item._id)"
              >
                <v-list-item-avatar>
                  <v-img
                    transition="false"
                    :src="$http.defaults.baseURL + '/images/' + item.image"
                    :lazy-src="$http.defaults.baseURL + '/images/' + item.lazyImage"
                  ></v-img>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title>{{item.name}}</v-list-item-title>
                  <v-list-item-subtitle><strong>{{item.title}}</strong></v-list-item-subtitle>
                  <v-list-item-subtitle>
                    <v-rating
                      :value="item.rating ? item.rating : 0"
                      color="yellow accent-4"
                      dense
                      half-increments
                      readonly
                      size="18"
                    ></v-rating>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-list-item-action-text>{{(item.distance * 0.001).toFixed(2)}} km from you</v-list-item-action-text>
                </v-list-item-action>
              </v-list-item>
            </template>
          </v-list>
          <v-btn
            v-if="results.length < totalCount"
            :loading="loadMore"
            :disabled="loadMore"
            tile
            block
            x-large
            color="success"
            @click="startSearch(true)"
          >Show more</v-btn>
        </v-tab-item>
      </v-tabs-items>
    </v-container>
    <v-overlay :value="!profile && !guestMode || isLoading" color="#036358">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-dialog
      v-model="serviceDialog"
      fullscreen
      elevation="0"
    >
      <Service :id="serviceId"/>
      <v-btn
        color="green"
        dark
        fixed
        left
        top
        fab
        v-if="serviceDialog"
        @click.stop="back"
      >
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
    </v-dialog>
    <v-dialog v-model="notificationDialog" persistent max-width="480">
      <v-card>
        <v-card-title class="text-h6"></v-card-title>
        <v-card-text>{{softTexts[softTextId]}}</v-card-text>
        <v-card-actions>
          <v-btn
            color="#CFCFCF"
            outlined
            tile
            elevation="0"
            @click="notificationDialog = false"
          >
            Maybe Later
          </v-btn>
          <v-btn
            color="green"
            @click="pushRegister()"
            dark
            tile
            elevation="0"
            full-width
            class="flex-grow-1"
          >
            Allow
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-bottom-sheet v-model="sheet">
      <v-sheet
        class="text-center"
        height="230px"
      >
        <div class="pt-6 pb-4"><strong>{{sheetTitle}}</strong></div>
        <v-btn
          class="px-15"
          color="green"
          dark
          @click="test(sheetId)"
          large
        >
          View Contact
        </v-btn>
        <br>
        <v-btn
          class="mt-4 px-15"
          color="green"
          outlined
          @click="navigate()"
          large
        >
          Get Directions
        </v-btn>
      </v-sheet>
    </v-bottom-sheet>
    <v-overlay :value="overlay"></v-overlay>
  </div>
</template>

<script>
// import L from 'leaflet'
import { LMap, LTileLayer, LMarker, LTooltip } from 'vue2-leaflet'

import { mapGetters } from 'vuex'

import Service from './Service'
import Ad from './Ad'

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LTooltip,
    Service,
    Ad
  },
  data () {
    return {
      tab: 1,
      type: null,
      types: ['An individual freelancer', 'Small business', 'Company'],
      searchArea: null,
      searchTerm: null,
      term: null,
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      zoom: 13,
      center: [6.69, -1.62],
      bounds: null,
      markers: [],
      rating: 4.3,
      items: ['Odumasi', 'Asawasi', 'Zongo', 'Aboabo', 'Dichemso', 'Dichemso', 'Dichemso', 'Dichemso'],
      search: null,
      map: null,
      name: 'map',
      drawer: false,
      dialog: false,
      tag: null,
      tags: ['Rating', 'Distance'],
      list: true,
      loadMore: false,
      isLoading: false,
      page: 0,
      radiusMap: [
        1, 5, 25, 300
      ],
      radius: 300,
      options: {
        permanent: true
      },
      serviceDialog: false,
      serviceId: null,
      isRefineMode: false,
      notificationDialog: false,
      overlay: false,
      softTextId: 0,
      softTexts: [
        'Welcome to FiXpert Ghana stay up-to-date with new features & notifications!',
        'FiXpert Ghana would like to keep you notified of app updates & new features!',
        'FiXpert Ghana would like to show you notifications for the latest news & updates!',
        'Never miss a new update or feature! Get notifications from FiXpert Ghana.',
        'Enjoy the full experience of FiXpert Ghana! Enable notifications to get the latest news, updates & features.'
      ],
      sheetService: null,
      sheetId: null,
      sheetTitle: '',
      sheet: false
    }
  },
  computed: {
    ...mapGetters(['area', 'areas', 'terms', 'profile', 'results', 'totalCount', 'guestMode']),
    radiusLabel () {
      return `Radius: ${this.radiusMap[this.radius]} km`
    }
  },
  async mounted () {
    this.$store.dispatch('searchAreas', '')
    this.$store.dispatch('searchTerms', '')

    if (!this.guestMode) {
      await this.$store.dispatch('getProfile')
    }

    const area = localStorage.getItem('area')
    if (this.guestMode && area) {
      this.$store.commit('updateSelectedArea', JSON.parse(area))
    }

    this.startSearch()

    // this.notificationDialog = true
    // this.softTextId = Math.floor(Math.random() * this.softTexts.length)
  },
  watch: {
    searchArea (val) {
      if (val && val.indexOf('/') > 0) return
      this.$store.dispatch('searchAreas', val)
    },
    searchTerm (val) {
      if (val && val.indexOf('/') > 0) return
      this.$store.dispatch('searchTerms', val)
    },
    $route (to, from) {
      if (this.serviceDialog && to.path.indexOf('service') === -1) {
        this.serviceDialog = false
      }
    }
  },
  methods: {
    openSheet (sheetService) {
      this.sheetId = sheetService._id
      this.sheetTitle = sheetService.name
      this.sheetService = sheetService
      this.sheet = !this.sheet
    },
    navigate () {
      const { location } = this.sheetService
      this.sheet = false
      const URL = `https://www.google.com/maps/dir/?api=1&travelmode=driving&destination=${location.coordinates[0]},${location.coordinates[1]}`
      window.open(URL, '_blank')
    },
    test (id) {
      this.sheet = false
      // this.$router.push('/service/' + id)
      // console.log(Notification.permission)
      if (!this.guestMode && Notification.permission === 'default') {
        const item = localStorage.getItem('activity')
        if (!item) {
          return localStorage.setItem('activity', JSON.stringify({ level: 10, times: 1 }))
        }

        const { level, times } = JSON.parse(item)
        const activity = {
          times: times + 1,
          level
        }

        localStorage.setItem('activity', JSON.stringify(activity))
      }

      this.serviceId = id
      this.serviceDialog = true
      this.$router.push('/service/' + id)
    },
    back () {
      this.serviceDialog = false
      this.$router.push('/search')

      if (!this.guestMode && Notification.permission === 'default') {
        const item = localStorage.getItem('activity')
        if (!item) {
          return localStorage.setItem('activity', JSON.stringify({ level: 10, times: 0 }))
        }

        const { level, times } = JSON.parse(item)
        if (times >= level) {
          const activity = {
            times: 0,
            level: level + 10
          }

          localStorage.setItem('activity', JSON.stringify(activity))
          this.softTextId = Math.floor(Math.random() * this.softTexts.length)
          this.notificationDialog = true
        }
      }
    },
    async pushRegister () {
      if (this.guestMode) return

      this.$ga.event('notifications', 'allow', this.softTexts[this.softTextId])

      this.notificationDialog = false
      localStorage.setItem('activity', JSON.stringify({ level: 10, times: 0 }))
      try {
        const token = await this.$messaging.getToken({ vapidKey: process.env.VUE_APP_VAPID_KEY })
        if (!token) return
        await this.$store.dispatch('setPushToken', token)

        this.$messaging.onMessage(function (payload) {
          const notificationTitle = payload.notification.title
          const notificationOptions = {
            body: payload.notification.body
          }

          const notification = new Notification(notificationTitle, notificationOptions)
          notification.onclick = function (event) {
            this.$ga.event('notifications', 'click')
            notification.close()
          }
        })
      } catch (e) {}
    },
    zoomUpdated (zoom) {
      this.zoom = zoom
    },
    centerUpdated (center) {
      this.center = center
    },
    boundsUpdated (bounds) {
      this.bounds = bounds
    },
    areaText: x => (x.city || x.state || '') +
      (x.city || x.state ? ' / ' + x.name : x.name),
    findLocation () {
      this.$refs.area.blur()
      this.isLoading = true
      navigator.geolocation.getCurrentPosition(async pos => {
        const location = {
          lat: pos.coords.latitude,
          lon: pos.coords.longitude
        }

        try {
          await this.$store.dispatch('getAreaByLocation', location)
        } catch (e) {
          const location = { lat: '6.6919', lon: '-1.6128' }
          await this.$store.dispatch('getAreaByLocation', location)
        }

        this.isLoading = false
        this.startSearch()
      }, err => {
        this.isLoading = false
        alert(err.message)
      })
    },
    categoryText: x => (x.category ? x.category : 'Others') + (x.title ? ' / ' + x.title : ''),
    changeArea (val) {
      this.$refs.area.blur()
      this.$store.commit('updateSelectedArea', val)
      this.startSearch()
    },
    clearStartSearch () {
      this.search = null
      this.startSearch()
    },
    async startSearch (append = false) {
      if (!this.area) return

      this.$refs.input.blur()
      if (this.isRefineMode) this.$refs.input2.blur()

      if (typeof append !== 'boolean' || !append) {
        this.page = 0
        this.list = false
      } else {
        this.page++
        this.loadMore = true
      }

      const typesMap = {
        'An individual freelancer': 'IF',
        'Small business': 'SB',
        Company: 'CO'
      }

      const query = {
        area: this.area,
        term: this.term,
        type: typesMap[this.type],
        search: this.search,
        sort: this.tag === 0 ? 'rating' : 'distance',
        radius: this.radiusMap[this.radius],
        page: this.page
      }

      await this.$store.dispatch('search', query)

      this.list = true
      this.loadMore = false
    },
    open () {
      // this.drawer = !this.drawer
      // this.$router.go(-1)
    },
    getLocation () {
      navigator.geolocation.getCurrentPosition(pos => {
        // this.gettingLocation = false
        // this.location = pos
        alert(JSON.stringify(pos.coords.latitude) + ', ' + JSON.stringify(pos.coords.longitude))
      }, err => {
        // this.gettingLocation = false
        // this.errorStr = err.message
        alert(err.message)
      })
    },
    toggleRefineMode () {
      this.isRefineMode = !this.isRefineMode

      if (this.type !== null || this.term !== null) {
        this.type = null
        this.term = null
        this.startSearch()
      }
    }
  }
}
</script>

<style>
  .input-background .v-input__control {
    background-image: url(https://unsplash.it/2000/1125?image=479);
    background-size: cover;
    background-position: center;
  }
  .input-background {
    color: red;
  }

  .v-slider__tick--filled {
    background-color: rgba(0, 0, 0, 0.5) !important;
    width: 2px !important;
  }

  .v-slider__tick {
    background-color: rgba(0, 0, 0, 0.5) !important;
    width: 2px !important;
  }

  .leaflet-tooltip {
    padding: 1px 6px !important;
  }

  .v-text-field > .v-input__control > .v-input__slot:before, .v-text-field > .v-input__control > .v-input__slot:after {
    display: none;
  }

  .search-bar .v-input__control {
    background: #EBD900;
    box-shadow: inset 1px 2px 9px -5px #000000;
  }

  .search-bar ::placeholder {
    color: #F11111 !important;
  }

  .tab-button {
    width: 50%;
    border: none;
    margin-bottom: -1px;
  }

  .tab-button-active:before {
    content: none;
  }

  .tab-button-active {
    z-index: 1;
  }

  .no-notranslate .no-icon {
    display: none;
  }

  .slide-chip {
    border-radius: 0 !important;
    box-shadow: 1px 2px 9px -5px #000000;
    display: flex; justify-content: center;
  }

  .slide-chip-active {
    box-shadow: inset 1px 2px 9px -5px #000000;
  }

  .v-slider__thumb {
    box-shadow: 1px 2px 7px -1px #000000;
  }

  .v-slider__thumb:before {
    content: none !important;
  }
</style>
